module.exports = __webpack_public_path__ + "static/media/Telefono-Activa-Banca.c4fa5b06.png";